import React, { useRef } from "react";
import { Upload, X } from "lucide-react";
import { Button } from "src/components/ui/button";

// A single image upload + preview. `url` is the current image (server or pending
// object URL); `onSelect(file)` stages a new one; `onClear` removes it.
export function ImageField({ url, onSelect, onClear, label = "image", aspect = "aspect-video", size = "" }) {
  const inputRef = useRef(null);

  return (
    <div className={`relative overflow-hidden rounded-lg border border-dashed border-slate-300 bg-slate-50 ${aspect} ${size}`}>
      {url ? (
        <>
          <img src={url} alt="" className="h-full w-full object-cover" />
          {onClear && (
            <button
              type="button"
              onClick={onClear}
              className="absolute right-1.5 top-1.5 rounded-full bg-white/90 p-1 text-slate-500 shadow hover:text-red-500"
              aria-label={`Remove ${label}`}
            >
              <X className="h-3.5 w-3.5" />
            </button>
          )}
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            className="absolute inset-x-0 bottom-0 bg-black/45 py-1 text-center text-[12px] font-medium text-white opacity-0 transition hover:opacity-100"
          >
            Replace
          </button>
        </>
      ) : (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          className="flex h-full w-full flex-col items-center justify-center gap-1 text-slate-400 hover:text-slate-600"
        >
          <Upload className="h-5 w-5" />
          <span className="text-[12px]">Upload {label}</span>
        </button>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onSelect(file);
          e.target.value = "";
        }}
      />
    </div>
  );
}
